import { text } from '../Constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getHeaderSecondaryButtonText = ({ isReviewBook, isReschedulePage }) => {
  if (isReviewBook) {
    if (isReschedulePage) {
      return text.BACK
    }
    return text.PREVIOUS
  }
  return text.CANCEL
}
